export const weight = <const>['semibold', 'medium'];
export type Weight = typeof weight[number];
